import {
  fetchAuthUser,
  setLanguage,
  setAuthToken,
  setAuth,
  setExpiresIn,
  setTokenCreatedAt,
  setAuthLoggedAs,
  setActiveApps,
  setNavCommunity,
  fetchPublicCommunity,
  setAuthUser as setAuthUserAction,
  saveCommunityLayoutSettings as saveCommunityLayoutSettingsAction,
  saveCommunityDrawersSettings as saveCommunityDrawersSettingsAction
} from "Actions";

import {
  getTTPUser,
  setSelectedOrganization,
  getSelectedOrganization,
  getPublicOrganization,
  getActiveApps,
  getClientCredential,
  saveCommunityLayoutSettings as saveCommunityLayoutSettingsApi,
  saveCommunityDrawersSettings as saveCommunityDrawersSettingsApi
} from "Api";

import {
  getAuthInfosFromCookie,
  authHasExpired,
  getLocalStorageAuth,
  setLocalStorageAuth,
  //redirectToHome,
  logout
} from "Utils";

export const setAuthUser = user => {
  return (dispatch, getState) => {
    dispatch(setAuthToken(user.token));
    dispatch(setExpiresIn(user.expiresIn));
    dispatch(setTokenCreatedAt(user.createdAt));
    dispatch(
      fetchAuthUser(
        getTTPUser({ userId: user.id, token: user.token }).then(res => {
          const help = typeof res === "string" ? JSON.parse(res) : res;
          const user = help.data[0];
          dispatch(setLanguage(user.language));
          dispatch(setAuthUserAction(user));
          dispatch(fetchNavCommunity());
          return user;
        }, err => err)
      )
    );
  };
};

export const login = () => {
  return (dispatch, getState) => {
    let authInfos = getAuthInfosFromCookie();
    if (!authInfos || authHasExpired(authInfos)) {
      setLocalStorageAuth(null);
      logout();
    }

    const auth = getLocalStorageAuth();
    if (auth && auth.user && authInfos.token === auth.token) {
      dispatch(setAuth(auth));

      const lng = localStorage.getItem("lng");
      if (!lng || lng.length === 0) {
        dispatch(setLanguage(auth.user.language));
      }
      const { navCommunity } = getState().auth;
      if (!navCommunity) {
        dispatch(fetchNavCommunity());
      }
    } else if (authInfos) {
      dispatch(setAuthUser(authInfos));
      dispatch(setAuthLoggedAs("MEMBER"));
    } else {
      dispatch(setAuthLoggedAs("GUEST"));
    }
  };
};

export const changeNavCommunity = organizationId => (dispatch, getState) => {
  const { token } = getState().auth;
  if (!token) {
    return false;
  }
  setSelectedOrganization({
    token,
    organizationId
  });
};

export const fetchNavCommunity = () => (dispatch, getState) => {
  const { token, navCommunity, user } = getState().auth;

  if (!token || !user) {
    return false;
  }

  return getSelectedOrganization(token).then(resp => {
    if (
      resp &&
      resp.data &&
      resp.data.organization &&
      (!navCommunity || navCommunity.id !== resp.data.organization.id)
    ) {
      const { organization } = resp.data;
      const chosed = user.communities.filter(com => organization.id === com.id);

      if (!chosed || chosed.length === 0) {
        dispatch(setAuthLoggedAs("CLIENT"));
      }

      dispatch(
        setNavCommunity(
          user && user.communities && chosed && chosed.length > 0
            ? chosed[0]
            : organization
        )
      );
    }
  });
};

export const fetchActiveApps = () => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;
  if (!token) {
    return false;
  }
  return dispatch(setActiveApps(getActiveApps(token, navCommunity.id)));
};

export const fetchPublicPortal = () => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    let subdomain = window.location.host;
    if (window.location.pathname.indexOf("/public/") !== -1) {
      subdomain += window.location.pathname;
      if (subdomain.charAt(subdomain.length - 1) === "/") {
        subdomain = subdomain.substring(0, subdomain.length - 1);
      }
    }

    if (!token || token === "") {
      return getClientCredential().done(resp => {
        const helpResp = typeof resp === "string" ? JSON.parse(resp) : resp;
        const token = helpResp.token.access_token;
        dispatch(setAuthToken(token));
        return dispatch(
          fetchPublicCommunity(getPublicOrganization(token, subdomain))
        );
      });
    }

    return dispatch(
      fetchPublicCommunity(getPublicOrganization(token, subdomain))
    );
  };
};

export const saveCommunityLayoutSettings = ({ layoutSettings }) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      saveCommunityLayoutSettingsAction(
        saveCommunityLayoutSettingsApi({
          token,
          communityId: navCommunity.id,
          layoutSettings
        })
      )
    );
  };
};

export const saveCommunityDrawersSettings = ({ drawers }) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      saveCommunityDrawersSettingsAction(
        saveCommunityDrawersSettingsApi({
          token,
          communityId: navCommunity.id,
          drawers
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/auth.js